import { useIsMobile } from './use-is-mobile';

export function useIsMobileIframe() {
  //   const isMobile = useIsMobile();
  const isIframe = typeof window !== 'undefined' && window.self !== window.top;

  return isIframe;
}
